/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useContext } from "react";

export interface LocaleContextType {
    currentLanguage: string;
    isLoading: boolean;
    changeLanguage: (lang: string) => void;
    fetchLanguages: (lang?: string) => Promise<void>;
    t: any;
}

export const AppLocaleContext = createContext<LocaleContextType | undefined>(undefined);

export const useAppLocale = () => {
    const context = useContext(AppLocaleContext);
    if (!context) {
        throw new Error('useAppLocale must be used within AppLocaleProvider');
    }
    return context;
};
